import { RestApiClient } from 'ifield-core-components'
import log from 'loglevel'

/**
 * 動線データクライアント
 */
export default class FlowlineDataClient {
  /**
   * コンストラクタ
   * @param {Boolean} storeCache キャッシュを貯める場合はtrue
   * @param {Function} postProcess 取得データに対する後処理
   */
  constructor({ storeCache, postProcess } = {}) {
    this.storeCache = storeCache == null ? true : storeCache
    this.postProcess = postProcess || null
    this._lastUrl = null
    this._dataCache = []
    this._promiseToFetch = null
  }

  /**
   * リクエスト先URLが前回と違う場合はtrue
   * @param {URL|String} url URL
   * @returns {Boolean}
   */
  _isUrlChanged(url) {
    const stringUrl = url.toString ? url.toString() : url
    return this._lastUrl !== stringUrl
  }

  /**
   * 動線強調マップ用データ取得
   * @param {URL|String} url URL
   * @returns {Promise.<Object>} 動線強調マップ用データ
   */
  async getData(url) {
    const isUrlChanged = this._isUrlChanged(url)

    if (this.storeCache) {
      // パラメータ変更が無くキャッシュがある場合は即時返却
      if (!isUrlChanged && this._dataCache.length) {
        log.info('return cached data')
        return this._dataCache
      }
    }

    // パラメータ変更時は強制的に新しくリクエストさせる
    if (isUrlChanged) {
      this._promiseToFetch = null
    }

    if (!this._promiseToFetch) {
      log.debug('create new request')
      this._promiseToFetch = RestApiClient.executeGetApi(url)
    } else {
      log.debug('share prev request')
    }
    // 別の処理でnullにされる場合を考慮してPromiseをコピーしておく
    const promise = this._promiseToFetch
    let json
    try {
      json = await promise
    } catch (error) {
      if (this._promiseToFetch) {
        this._promiseToFetch = null
      }
      throw error
    }
    const data = this.postProcess ? this.postProcess(json.data) : json.data
    if (this.storeCache) {
      this._dataCache = data
    }
    if (this._promiseToFetch) {
      this._promiseToFetch = null
    }
    this._lastUrl = url.toString ? url.toString() : url
    return data
  }

  /**
   * 中断処理(何もしない)
   */
  abort() {}
}
